import { render, staticRenderFns } from "./CreateEventForm.vue?vue&type=template&id=3748de2e&scoped=true&"
import script from "./CreateEventForm.vue?vue&type=script&lang=js&"
export * from "./CreateEventForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateEventForm.vue?vue&type=style&index=0&id=3748de2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748de2e",
  null
  
)

export default component.exports